import { MatSnackBarConfig } from '@angular/material/snack-bar';

import { SnackbarDataType } from './snackbar.component';

const DURATION = 7000;

export enum SnackbarType {
  success = 'success',
  error = 'error'
}

export class SnackbarConfig {
  static success: Partial<MatSnackBarConfig<Partial<SnackbarDataType>>> = {
    duration: DURATION,
    panelClass: ['snackbar', SnackbarType.success],
    data: { type: SnackbarType.success }
  };

  static error: Partial<MatSnackBarConfig<Partial<SnackbarDataType>>> = {
    duration: DURATION,
    panelClass: ['snackbar', SnackbarType.error],
    data: { type: SnackbarType.error }
  };
}
